import React, {useState} from 'react';
import {Flex, message} from "antd";
import {InboxOutlined} from "@ant-design/icons";
import IntlMessage from "../../../../../components/IntlMessage/IntlMessage";
import HorizontalDivider from "../../../../../components/Divider/HorizontalDivider";
import Dragger from "antd/es/upload/Dragger";
import CourseService from "../../../../../services/CourseService";
import {clrs} from "../../../../../constants/colors";
import GreyButton from "../../../../../components/UI/Buttons/GreyButton";
import BlockLoading from "../../../../../components/LoadingComponents/BlockLoading";

const ImportSubjectsListeners = () => {
    const [isLoadingCreate, setIsLoadingCreate] = useState(false);
    const [uploadedFile, setUploadedFile] = useState(null);

    const handleChangeExcel = (info) => {
        // Сохраняем выбранный файл в state
        setUploadedFile(info.file);
        // Никакой загрузки на сервер пока
    };

    const propsOtherFiles = {
        beforeUpload: () => false,
        onChange: handleChangeExcel,
        multiple: false,
    };

    const importExcel = async () => {
        setIsLoadingCreate(true)
        if (!uploadedFile) {
            message.error(<IntlMessage id="file.required" defaultMessage="Please upload a file"/>, 5);
            return;
        }
        try {
            await CourseService.convertExcelToListenersSubjects(uploadedFile);
            message.success(<IntlMessage id="success"/>, 5);
            setUploadedFile(null);
        } catch (error) {
            message.error(<IntlMessage id="error"/>, 5);
        } finally {
            setIsLoadingCreate(false);
        }
    }

    return (
        <Flex align={"flex-start"} vertical justify={"flex-start"} gap={10} style={{width: "100%"}}>
            <BlockLoading isLoading={isLoadingCreate}/>
            {/*<Upload {...propsOtherFiles} fileList={[]}>*/}
            {/*    <AntdButton icon={<UploadOutlined/>}><IntlMessage id={'upload'}/></AntdButton>*/}
            {/*</Upload>*/}
            <div style={{width: "100%"}}>
                <Dragger {...propsOtherFiles} fileList={uploadedFile ? [uploadedFile] : []}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined/>
                    </p>
                    <p className="ant-upload-text"><IntlMessage id={"certificate.dragFileExcel"}/></p>
                    <p className="ant-upload-hint">
                        <IntlMessage id={"certificate.dragFileExcel2"}/>
                    </p>
                </Dragger>

            </div>

            <HorizontalDivider/>
            {/*<FileList files={getForm.form?.otherFiles} setIsLoading={setIsLoadingOtherFiles}/>*/}
            <GreyButton
                onClick={importExcel}
                backgroundColor={clrs.blackerBlue}
                fontColor={clrs.white}
            >
                <IntlMessage id="create"/>
            </GreyButton>
        </Flex>
    );
};

export default ImportSubjectsListeners;